/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Extract_Complete_LogInputs */



/**
* | output |
* | --- |
* | "-----Extracting closed caption process complete-----" |
*
* @param {Drastic_Tech_Extract_Complete_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_extract_complete_log = /** @type {((inputs?: Drastic_Tech_Extract_Complete_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Extract_Complete_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("-----Processus d'extraction termine-----")
	if (locale === "de") return /** @type {LocalizedString} */ ("-----Extrahieren der Untertitel abgeschlossen-----")
	if (locale === "it") return /** @type {LocalizedString} */ ("-----Processo di estrazione dei sottotitoli completato-----")
	if (locale === "ru") return /** @type {LocalizedString} */ ("-----Процесс извлечения субтитров завершен-----")
	if (locale === "es") return /** @type {LocalizedString} */ ("-----Proceso de extracción de subtítulos completado-----")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("-----字幕提取过程完成-----")
	if (locale === "ja") return /** @type {LocalizedString} */ ("-----クローズドキャプションの抽出プロセスが完了しました-----")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्लोज्ड कैप्शन निकालने की प्रक्रिया पूरी हुई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("-----Processo de extração de legendas concluído-----")
	return /** @type {LocalizedString} */ ("-----Extracting closed caption process complete-----")
});